
        module.exports = __webpack_public_path__ + "assets/images/climat-logo.d048e57f.svg";;

        var src = '' + module.exports;

        module.exports = {

            src: src,
            width: 1024,
            height: 1024,
            type: "svg",
            bytes: 2440,

            toString: function() {
                return src;
            }
        };
    